import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  searchSlide: {
    method: 'GET',
    url: `${configs.baseUrl}/api/search/slide/`,
  },
  searchPresentation: {
    method: 'GET',
    url: `${configs.baseUrl}/api/search/presentation/`,
  },
  getTotalResult: {
    method: 'GET',
    url: `${configs.baseUrl}/api/search/global/`,
  },

}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const searchSlide = (params) => {
  return resource.searchSlide(params)
}

const searchPresentation = (params) => {
  return resource.searchPresentation(params)
}

const getTotalResult = (params) => {
  return resource.getTotalResult(params)
}

export default {
  initResource,
  searchSlide,
  searchPresentation,
  getTotalResult,
}
